exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 50px;\n  height: 100%;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background: #003a62;\n  text-align: center;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/not-found/not-found.component.scss
// module id = ../../../../../src/app/shared/components/not-found/not-found.component.scss
// module chunks = main